module.exports = __webpack_public_path__ + "img/latitude.da3a7041.svg";